
export const ROUTE = "/hoasen"
//const current_url = window.location.href;
const current_url = 'https://annhon.ailab.vn/';
const http_ = current_url.split('/')[2];
export const IP = http_.split(':')[0];
export const SERVER = "https://"+ IP + ":5333";
